module.exports = __webpack_public_path__ + "static/media/manifest.42c18267.svg";